import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q3Fields({ handleUpdate, errors, q3_3 }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>3. Hotel Reservation Process</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="3.1 How easy was it for you to manage and support hotel reservations through the dashboard?"
					reqd={true}
					data={[
						{
							name: "q3_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q3_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q3_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q3_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q3_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q3_1") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="3.2 How clear were the hotel options, deadlines, and policies communicated within the dashboard?"
					reqd={true}
					data={[
						{
							name: "q3_2",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q3_2",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q3_2",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q3_2",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q3_2",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q3_2") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="3.3 Did your attendees raise any concerns or confusion about hotel reservations?"
					reqd={true}
					data={[
						{
							name: "q3_3",
							val: "Yes",
							label: "Yes",
						},
						{
							name: "q3_3",
							val: "No",
							label: "No",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q3_3") ? true : false}
				/>
			</div>

			{q3_3 === "Yes" && (
				<div className="form-group one indent" style={{ marginTop: "0px" }}>
					<Input
						name="q3_3a"
						label="Please describe:"
						reqd={true}
						value={""}
						autocomplete="off"
						update={handleUpdate}
						errors={errors}
					/>
				</div>
			)}

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q3_4"
					label="3.4 What could improve the hotel reservation experience for you or your attendees?"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
